import { Grid, InputLabel } from "@mui/material";
import React from "react";
import { StyledTextInput } from "./styled";

export const BITextFieldForm = ({
  input: { name, ...restInput },
  meta,
  label,
  required,
  children,
  maxLength,
  minLength,
  ...rest
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <InputLabel
          shrink={false}
          htmlFor={name}
          required={required}
          error={meta.error && meta.touched}
        >
          {label}
        </InputLabel>

        <StyledTextInput
          {...rest}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name={name}
          helperText={meta.touched ? meta.error : undefined}
          error={meta.error && meta.touched}
          inputProps={{ ...restInput, maxLength, minLength }}
          required={required}
        >
          {children}
        </StyledTextInput>
      </Grid>
    </Grid>
  );
};

export default BITextFieldForm;
